import React, { useContext } from "react";
import {
  DialogContent,
  DialogActions,
  Button,
  Dialog,
  makeStyles,
  Paper,
  Typography,
  IconButton,
} from "@material-ui/core";
import { IoMdClose } from "react-icons/io";
import { LangContext } from "../../Context/Langcontext";

const useStyle = makeStyles((theme) => ({
  root: {
    width: "95%",
    height: "95%",
  },
  btnstylesubmit: {
    borderRadius: 8,
    padding: "0.4rem 2rem",
    fontSize: "1rem",
    fontWeight: 200,
    textTransform: "unset",
    backgroundColor: "#E16733",
    color: "#FFFFFF",
    "&:hover": {
      background: "#e16733",
      boxShadow: `0px 0px 20px -1px #a8a8a8`,
      transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    },
  },
  btnstylecancel: {
    borderRadius: 8,
    padding: "0.4rem 2rem",
    fontSize: "1rem",
    fontWeight: 200,
    textTransform: "unset",
    backgroundColor: "#BFC0BF",
    color: "#595A5A",
    "&:hover": {
      backgroundColor: "#BFC0BF",
      boxShadow: `0px 0px 20px -1px #a8a8a8`,
      transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    },
  },
  paper: {
    backgroundColor: "#E16733",
    borderRadius: 4,
    height: "4rem",
    display: "flex",
    alignItems: "center",
    boxShadow: "unset",
    justifyContent: "space-between",
  },
  dialog: {
    "& .MuiDialog-paperFullWidth": { borderRadius: 10 },
    "& .MuiDialogContent-root:first-child": {
      paddingTop: 10,
    },
  },
  headtext: {
    fontSize: "1.2rem",
    color: "#faf7f1",
    fontWeight: 200,
    marginLeft: "2.5rem",
  },
  closeicon: {
    color: "#faf7f1",
  },
  icnclose: {
    marginRight: "2rem",
  },
  btndis: {
    borderRadius: 8,
    padding: "0.4rem 2rem",
    fontSize: "1rem",
    fontWeight: 200,
    textTransform: "unset",
    backgroundColor: "#ebebeb",
    color: "#FFFFFF",
  },
}));
const DialogOpen = ({
  open,
  handleClose,
  header,
  children,
  genapi,
  type,
  update,
}) => {
  const classes = useStyle();
  const langContext = useContext(LangContext);
  const lang = langContext.lang.data;
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="form-dialog-title"
      maxWidth="sm"
      fullWidth={true}
      className={classes.dialog}
    >
      <Paper className={classes.paper}>
        <Typography className={classes.headtext}>{header}</Typography>
        <IconButton className={classes.icnclose} onClick={handleClose}>
          <IoMdClose className={classes.closeicon} size={20} />
        </IconButton>
      </Paper>
      <div style={{ margin: "1rem" }}>
        <form onSubmit={genapi}>
          <DialogContent className={classes.content}>{children}</DialogContent>
          <DialogActions>
            <Button className={classes.btnstylecancel} onClick={handleClose}>
              {lang.Cancel}
            </Button>
            <Button
              className={update ? classes.btndis : classes.btnstylesubmit}
              type="submit"
              disabled={update}
              // onClick={type === "create" ? genapi : genapi}
            >
              {type === "create"
                ? lang.Submit
                : type === "update"
                ? lang.Update
                : lang.Delete}
            </Button>
          </DialogActions>
        </form>
      </div>
    </Dialog>
  );
};

export default DialogOpen;
